export default __webpack_public_path__ + "static/media/sort.c49cc0dc.svg";